/* eslint-disable ember/classic-decorator-hooks, ember/classic-decorator-no-classic-methods, ember/no-get, ember/no-mixins, ember/require-computed-property-dependencies, getter-return, warp-drive/no-legacy-request-patterns */
import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import EditPostMixin from '@linc-technologies/linced-common/mixins/edit-post';
import { service } from '@ember/service';
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import { isMobile } from '@linc-technologies/linced-common/utils/platform';
import { action, computed } from '@ember/object';
import { isEmpty } from '@ember/utils';

export default class PageController extends Controller.extend(EditPostMixin) {
  PersonType = PersonType;

  // Services
  @service
  router;

  @service
  session;

  @service
  store;

  @tracked
  isMobile;

  init() {
    super.init(...arguments);
    this.isMobile = isMobile();
  }

  @computed('model.{page.hasAssessments,assessments.length}')
  get assessment() {
    if (
      this.model.page.get('hasAssessments') &&
      this.model.assessments.length === 1
    ) {
      return this.model.assessments.at(0);
    }
  }

  @computed('assessment.id')
  get assessmentModules() {
    if (!isEmpty(this.assessment)) {
      return this.store.query('assessments/module', {
        assessmentId: this.assessment.id,
      });
    }
  }

  @computed('assessment.id', 'numGradeChanges')
  get latestGrades() {
    if (!isEmpty(this.assessment)) {
      let filter = {
        personId: this.session.person.id,
        assessmentId: this.assessment.id,
        latest: true,
      };
      return this.store.query('assessments/grade', filter);
    }
  }

  @computed('model.posts.@each.raw_assessment_id')
  get unlinkedPosts() {
    return this.model.posts.filter((post) => !post.raw_assessment_id);
  }

  @action
  refresh() {
    this.get('model.posts').update();
  }
}
